<template>
  <div class="wheat-mall pk-account-panel">
    <section class="wheat-hero">
      <div class="wheat-copy">
        <span>小麦商城</span>
        <h1>小麦商城</h1>
        <p>使用小麦币按站内饰品等价价格兑换。兑换成功后饰品立即进入背包，可正常回收或申请取回。</p>
        <button @click="loadData">刷新商品</button>
      </div>
      <div class="wheat-balance">
        <span>当前小麦币</span>
        <strong>{{ moneyText($store.state.masonry) }}</strong>
        <em></em>
      </div>
    </section>

    <section class="wheat-board">
      <header>
        <div>
          <span>饰品选购</span>
          <h2>可兑换饰品</h2>
        </div>
        <div class="wheat-board-actions">
          <input v-if="!openOrders" v-model.trim="keyword" placeholder="搜索饰品名称" @keyup.enter="getGoods(1)" />
          <button v-if="!openOrders" @click="getGoods(1)">搜索</button>
          <button @click="toggleOrders">{{ openOrders ? "查看饰品" : "兑换记录" }}</button>
        </div>
      </header>

      <div v-if="!openOrders" class="wheat-grid">
        <article v-for="item in goods" :key="item.id" class="wheat-card">
          <div class="skin-labels">
            <span>{{ item.exteriorName || "普通" }}</span>
            <em>{{ item.rarityName || item.qualityName || "饰品" }}</em>
          </div>
          <div class="wheat-img">
            <img :src="item.image_url || defaultGoodsImg" alt="" @error="useGoodsFallback" />
          </div>
          <strong>{{ item.name }}</strong>
          <p>{{ item.description || "使用等价小麦币兑换，成功后立即进入背包。" }}</p>
          <div class="wheat-meta">
            <span>{{ moneyText(item.price_masonry) }} <i></i></span>
            <b>商城库存 {{ item.stock }}</b>
          </div>
          <div class="wheat-card-actions">
            <button class="detail" @click="openDetail(item)">商品详情</button>
            <button @click="openExchange(item)">立即兑换</button>
          </div>
        </article>
      </div>

      <div v-if="!openOrders && !goods.length" class="wheat-empty">未找到可兑换饰品</div>

      <el-pagination
        v-if="!openOrders && total > pageSize"
        class="wheat-pagination"
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="pageSize"
        :current-page="page"
        @current-change="getGoods"
      ></el-pagination>

      <div v-if="openOrders" class="wheat-orders">
        <article v-for="order in orders" :key="order.id" class="wheat-order">
          <div>
            <strong>{{ order.goods_name }}</strong>
            <span>{{ order.order_no || `历史订单 #${order.id}` }} · {{ order.create_time }}</span>
            <small>{{ order.fulfillment_type === "backpack" ? "饰品已自动发放至背包" : "历史人工订单" }}</small>
            <p v-if="order.admin_remark" class="wheat-order-note">处理备注：{{ order.admin_remark }}</p>
          </div>
          <p>{{ order.quantity }} 件 / {{ moneyText(order.total_masonry) }} 小麦币</p>
          <div class="order-status"><em :class="'status-' + order.status">{{ order.status_name }}</em><button v-if="order.fulfillment_type === 'backpack'" @click="goBackpack">查看背包</button></div>
        </article>
        <div v-if="!orders.length" class="wheat-empty">暂无兑换记录</div>
      </div>
    </section>

    <div v-if="exchangeVisible" class="wheat-modal">
      <div class="wheat-dialog">
        <button class="wheat-close" @click="exchangeVisible = false">×</button>
        <h3>确认兑换</h3>
        <strong>{{ currentGoods.name }}</strong>
        <p>将消耗 {{ moneyText(exchangeTotal) }} 小麦币。确认后饰品立即进入背包，可继续回收或申请取回。</p>
        <label>
          数量
          <input v-model.number="exchange.quantity" type="number" min="1" :max="currentGoods.stock" />
        </label>
        <button class="wheat-submit" :disabled="submitting" @click="submitExchange">
          {{ submitting ? "提交中..." : "确认兑换" }}
        </button>
      </div>
    </div>

    <div v-if="detailVisible" class="wheat-modal">
      <div class="wheat-dialog wheat-detail-dialog">
        <button class="wheat-close" @click="detailVisible = false">×</button>
        <img :src="currentGoods.image_url || defaultGoodsImg" alt="" @error="useGoodsFallback" />
        <span>商品详情</span>
        <h3>{{ currentGoods.name }}</h3>
        <p>{{ currentGoods.description || "暂无商品说明" }}</p>
        <div class="wheat-detail-tags"><span>{{ currentGoods.exteriorName || "普通" }}</span><span>{{ currentGoods.rarityName || currentGoods.qualityName || "饰品" }}</span></div>
        <div class="wheat-detail-meta"><strong>{{ moneyText(currentGoods.price_masonry) }} 小麦币</strong><em>商城库存 {{ currentGoods.stock }}</em></div>
        <button class="wheat-submit" @click="detailVisible = false; openExchange(currentGoods)">立即兑换</button>
      </div>
    </div>
  </div>
</template>

<script>
import Utils from "./../assets/js/util.js";

export default {
  name: "WheatMall",
  data() {
    return {
      goods: [],
      orders: [],
      total: 0,
      page: 1,
      pageSize: 24,
      openOrders: false,
      exchangeVisible: false,
      detailVisible: false,
      submitting: false,
      currentGoods: {},
      keyword: "",
      exchange: {
        quantity: 1,
      },
      defaultGoodsImg: require("../assets/hotpizza/hp-case-green.png"),
    };
  },
  mounted() {
    this.loadData();
  },
  computed: {
    loggedIn() {
      return Boolean(this.$store.state.token || localStorage.getItem("token"));
    },
    exchangeTotal() {
      return Number(this.currentGoods.price_masonry || 0) * Number(this.exchange.quantity || 1);
    },
  },
  methods: {
    moneyText(value) {
      return Number(value || 0).toFixed(2);
    },
    useGoodsFallback(event) {
      event.target.src = this.defaultGoodsImg;
    },
    loadData() {
      this.getGoods(this.page);
      if (this.loggedIn) {
        this.getOrders();
      }
    },
    getGoods(page = 1) {
      this.page = page;
      this.$axios.post("/index/Wheat_mall/goodsList", this.$qs.stringify({ page: this.page, pageSize: this.pageSize, keyword: this.keyword })).then((res) => {
        if (res.data.status == 1) {
          this.goods = res.data.data.list || [];
          this.total = Number(res.data.data.total || 0);
        }
      });
    },
    getOrders() {
      this.$axios.post("/index/Wheat_mall/myOrders", this.$qs.stringify({ page: 1, pageSize: 20 })).then((res) => {
        if (res.data.status == 1) {
          this.orders = res.data.data.list || [];
        }
      });
    },
    toggleOrders() {
      if (!this.openOrders && !this.loggedIn) {
        this.openLogin();
        return;
      }
      this.openOrders = !this.openOrders;
      if (this.openOrders && this.loggedIn) {
        this.getOrders();
      }
    },
    openExchange(item) {
      if (!this.loggedIn) {
        this.openLogin();
        return;
      }
      this.currentGoods = item;
      this.exchange = { quantity: 1 };
      this.exchangeVisible = true;
    },
    openDetail(item) {
      this.currentGoods = item;
      this.detailVisible = true;
    },
    openLogin() {
      this.$store.commit("getLogin", true);
    },
    submitExchange() {
      if (!this.currentGoods.id) return;
      this.submitting = true;
      const payload = {
        goods_id: this.currentGoods.id,
        quantity: this.exchange.quantity || 1,
      };
      this.$axios
        .post("/index/Wheat_mall/createOrder", this.$qs.stringify(payload))
        .then((res) => {
          if (res.data.status == 1) {
            this.$message.success(res.data.msg || "兑换成功，饰品已进入背包");
            this.$store.commit("getMasonry", res.data.data.masonry);
            Utils.$emit("masonry", res.data.data.masonry);
            const userInfo = JSON.parse(localStorage.getItem("userInfo") || "null");
            if (userInfo) {
              userInfo.masonry = res.data.data.masonry;
              localStorage.setItem("userInfo", JSON.stringify(userInfo));
            }
            this.exchangeVisible = false;
            this.getGoods(this.page);
            this.getOrders();
          } else {
            this.$message.error(res.data.msg || "兑换失败");
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    },
    goBackpack() {
      this.$router.push({ path: "/Dota" });
    },
  },
};
</script>

<style lang="less" scoped>
.wheat-mall {
  min-height: calc(100vh - 198px);
  padding: 34px 34px 90px;
  color: #f6f0df;
  background:
    radial-gradient(circle at 50% 0, rgba(255, 177, 55, 0.18), transparent 32%),
    radial-gradient(circle at 82% 26%, rgba(72, 232, 146, 0.12), transparent 30%),
    linear-gradient(180deg, #20222e 0%, #171923 100%);
}

button,
input,
textarea {
  font-family: inherit;
}

button {
  cursor: pointer;
}

.wheat-hero,
.wheat-board {
  width: 100%;
  max-width: 1540px;
  margin: 0 auto;
}

.wheat-hero {
  min-height: 330px;
  padding: 44px;
  display: grid;
  grid-template-columns: 1fr 340px;
  gap: 28px;
  align-items: center;
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(255, 163, 26, 0.34);
  border-radius: 18px;
  background:
    radial-gradient(circle at 72% 40%, rgba(255, 180, 63, 0.24), transparent 34%),
    linear-gradient(132deg, rgba(44, 38, 31, 0.98), rgba(26, 28, 39, 0.98));
  box-shadow: 0 28px 86px rgba(0, 0, 0, 0.35);
}

.wheat-hero::after {
  content: "";
  width: 520px;
  height: 210px;
  position: absolute;
  right: 70px;
  bottom: -90px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255, 197, 77, 0.26), rgba(255, 197, 77, 0.04) 64%, transparent 72%);
}

.wheat-copy,
.wheat-balance {
  position: relative;
  z-index: 1;
}

.wheat-copy span,
.wheat-board header span {
  color: #ff9f23;
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0.18em;
}

.wheat-copy h1 {
  margin: 14px 0;
  color: #fff7e5;
  font-size: 70px;
  line-height: 0.95;
  font-weight: 1000;
}

.wheat-copy p {
  max-width: 640px;
  margin: 0 0 28px;
  color: #c8bfae;
  font-size: 16px;
  line-height: 1.8;
  font-weight: 800;
}

.wheat-copy button,
.wheat-board header button,
.wheat-card button,
.wheat-submit {
  height: 48px;
  padding: 0 26px;
  color: #20150a;
  font-size: 16px;
  font-weight: 1000;
  border: 0;
  border-radius: 8px;
  background: linear-gradient(180deg, #ffd576, #ff8a1f);
  box-shadow: 0 12px 26px rgba(255, 132, 31, 0.28);
}

.wheat-board-actions { display: flex; align-items: center; gap: 10px; }
.wheat-board-actions input { width: 210px; height: 42px; padding: 0 13px; color: #f8f1df; border: 1px solid #494d5e; border-radius: 7px; outline: 0; background: #20232e; }
.wheat-card-actions { display: flex; gap: 8px; }
.wheat-card-actions button { flex: 1; min-width: 0; }
.wheat-card-actions .detail { color: #c8cbd5; border: 1px solid #4d5264; background: #303342; box-shadow: none; }
.wheat-detail-dialog { text-align: center; }
.wheat-detail-dialog > img { width: 180px; height: 150px; margin: 0 auto 12px; object-fit: contain; }
.wheat-detail-dialog > span { display: block; color: #ffad3a; font-size: 11px; font-weight: 900; letter-spacing: .14em; }
.wheat-detail-dialog > p { color: #aeb3c0; line-height: 1.7; }
.wheat-detail-meta { display: flex; justify-content: center; gap: 18px; margin: 18px 0; }
.wheat-detail-meta strong { color: #ffd16a; }
.wheat-detail-meta em { color: #aeb3c0; font-style: normal; }

.wheat-detail-tags {
  display: flex;
  justify-content: center;
  gap: 8px;
}

.wheat-detail-tags span {
  padding: 5px 9px;
  color: #ffbd58;
  font-size: 12px;
  font-weight: 900;
  border-radius: 999px;
  background: rgba(255, 173, 58, 0.1);
}

@media (max-width: 720px) { .wheat-board-actions { width: 100%; flex-wrap: wrap; } .wheat-board-actions input { width: 100%; } }

.wheat-balance {
  min-height: 190px;
  padding: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 18px;
  background: rgba(22, 24, 34, 0.78);
  border: 1px solid rgba(255, 215, 126, 0.18);
}

.wheat-balance span {
  color: #aeb5c5;
  font-size: 14px;
  font-weight: 900;
}

.wheat-balance strong {
  margin-top: 10px;
  color: #ffd576;
  font-size: 54px;
  line-height: 1;
}

.wheat-balance em {
  width: 118px;
  height: 118px;
  position: absolute;
  right: 20px;
  bottom: 12px;
  opacity: 0.72;
  background: url("../assets/pizzaking/wheat-token.svg") center / contain no-repeat;
}

.wheat-board {
  margin-top: 28px;
  padding: 26px;
  border-radius: 18px;
  background: rgba(29, 31, 43, 0.92);
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.wheat-board header {
  display: flex;
  justify-content: space-between;
  gap: 18px;
  align-items: center;
  margin-bottom: 22px;
}

.wheat-board h2 {
  margin: 6px 0 0;
  color: #fff;
  font-size: 28px;
}

.wheat-board header button {
  height: 42px;
  color: #fff7e5;
  border: 1px solid rgba(255, 215, 126, 0.32);
  background: rgba(255, 255, 255, 0.06);
  box-shadow: none;
}

.wheat-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 18px;
}

.wheat-card,
.wheat-order {
  border: 1px solid rgba(255, 255, 255, 0.07);
  border-radius: 14px;
  background: linear-gradient(180deg, rgba(45, 48, 63, 0.94), rgba(35, 37, 50, 0.98));
}

.wheat-card {
  min-height: 348px;
  padding: 18px;
}

.skin-labels {
  min-height: 24px;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  gap: 8px;
  color: #9fa8bc;
  font-size: 12px;
  font-weight: 900;
}

.skin-labels em {
  color: #ffad3a;
  font-style: normal;
}

.wheat-img {
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background:
    radial-gradient(circle, rgba(255, 172, 43, 0.22), transparent 62%),
    rgba(17, 19, 28, 0.5);
}

.wheat-img img {
  max-width: 86%;
  max-height: 130px;
  object-fit: contain;
  filter: drop-shadow(0 18px 24px rgba(0, 0, 0, 0.42));
}

.wheat-card strong {
  display: block;
  margin-top: 16px;
  color: #fff;
  font-size: 18px;
}

.wheat-card p {
  min-height: 44px;
  margin: 8px 0 16px;
  color: #aeb5c5;
  line-height: 1.6;
}

.wheat-meta {
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
  color: #ffd576;
  font-weight: 900;
}

.wheat-meta b {
  color: #8f98aa;
}

.wheat-meta i {
  width: 18px;
  height: 18px;
  display: inline-block;
  vertical-align: -4px;
  background: url("../assets/pizzaking/wheat-token.svg") center / contain no-repeat;
}

.wheat-card button {
  width: 100%;
}

.wheat-empty {
  padding: 34px;
  color: #8f98aa;
  text-align: center;
}

.wheat-pagination {
  margin-top: 24px;
  display: flex;
  justify-content: center;
}

.wheat-orders {
  display: grid;
  gap: 12px;
}

.wheat-order {
  padding: 18px;
  display: grid;
  grid-template-columns: 1fr 180px 110px;
  gap: 16px;
  align-items: center;
}

.wheat-order strong {
  display: block;
  color: #fff;
}

.wheat-order span,
.wheat-order p {
  color: #aeb5c5;
}

.wheat-order small {
  display: block;
  margin-top: 7px;
  color: #c8b47e;
  font-size: 12px;
  font-weight: 900;
}

.wheat-order .wheat-order-note {
  margin: 8px 0 0;
  color: #d8dfec;
  line-height: 1.55;
}

.wheat-order em {
  padding: 8px 12px;
  text-align: center;
  font-style: normal;
  font-weight: 1000;
  border-radius: 999px;
  color: #ffd576;
  background: rgba(255, 213, 118, 0.12);
}

.wheat-order em.status-1 {
  color: #6edcff;
  background: rgba(110, 220, 255, 0.12);
}

.wheat-order em.status-2 {
  color: #6effa0;
  background: rgba(110, 255, 160, 0.12);
}

.wheat-order em.status-3 {
  color: #ff6a74;
  background: rgba(255, 106, 116, 0.12);
}

.order-status {
  display: grid;
  gap: 8px;
}

.order-status button {
  height: 34px;
  color: #ffd576;
  font-weight: 900;
  border: 1px solid rgba(255, 213, 118, 0.26);
  border-radius: 7px;
  background: rgba(255, 213, 118, 0.08);
}

.wheat-modal {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(7, 8, 13, 0.72);
}

.wheat-dialog {
  width: 460px;
  padding: 30px;
  position: relative;
  color: #f6f0df;
  border-radius: 18px;
  background: #222432;
  border: 1px solid rgba(255, 213, 118, 0.22);
}

.wheat-close {
  width: 34px;
  height: 34px;
  position: absolute;
  right: 16px;
  top: 16px;
  color: #fff;
  border: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.08);
}

.wheat-dialog h3 {
  margin: 0 0 16px;
  font-size: 28px;
}

.wheat-dialog > strong {
  display: block;
  color: #ffd576;
  font-size: 18px;
}

.wheat-dialog p {
  color: #aeb5c5;
}

.wheat-dialog label {
  display: block;
  margin-top: 14px;
  color: #c8cfdd;
  font-weight: 900;
}

.wheat-dialog input,
.wheat-dialog textarea {
  width: 100%;
  margin-top: 8px;
  padding: 12px;
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 10px;
  background: #171923;
  outline: none;
}

.wheat-dialog textarea {
  height: 88px;
  resize: none;
}

.wheat-submit {
  width: 100%;
  margin-top: 20px;
}

@media (max-width: 1180px) {
  .wheat-hero {
    grid-template-columns: 1fr;
  }

  .wheat-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 700px) {
  .wheat-mall {
    padding: 22px 14px 70px;
  }

  .wheat-hero {
    padding: 28px;
  }

  .wheat-copy h1 {
    font-size: 48px;
  }

  .wheat-grid,
  .wheat-order {
    grid-template-columns: 1fr;
  }

  .wheat-order > p {
    margin: 0;
  }

  .wheat-dialog {
    width: calc(100vw - 28px);
  }
}
</style>
